import L from 'leaflet';
import moment from 'moment';
import { getConfig } from '../../config';

export default class MarkerPopup extends L.Popup {
    constructor(object, data, latLng, map) {
        super();
        this.config = getConfig();
        this.setLatLng(latLng);
        this.title = object.name;
        this.IMEI = object.IMEI;
        this.sensors = data.sensors;
        this.dt = moment(fmtools.getLocalDateTime(data.dt)).format(messages['moment_data_time_format']);
        this.map = map;
        this.initSize(this.config);
        this.options.offset = new L.Point(-10, -15);
        this.options.className = 'fort-map-popup';
    }

    show() {
        this.markup = this._getMarkup();
        this.setContent(this.markup);
        this.openOn(this.map);
    }

    initSize(config) {
        this.options.minWidth = config.popup.minWidth;
        this.options.maxHeight = config.popup.maxHeight;
    }

    _getMarkup() {
        return `
            <div class="x-panel x-border-item item-info">
                <div class="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl">
                    <div class="fort-popup-title" style="text-align: center;" title="${this.title}">
                        ${this.title}
                    </div>
                    <div class="x-panel scroll-pane x-grid-header-hidden x-fit-item x-panel-default x-grid popup-body" style="max-height: 355px; overflow: auto;">             
                        <div class=" x-grid-with-row-lines x-panel-body-default x-panel-body-default x-noborder-trbl">
                            <div class="x-grid-view x-grid-with-row-lines x-fit-item x-grid-view-default">
                                <div class="x-grid-item-container">
                                    <table>
                                        <tbody>
                                            ${this._renderMapLinksRow()}
                                            ${this._renderParamRow(messages['IMEI'], '', this.IMEI, '')}
                                            ${this._renderParamRow(messages['Time'], "last_connect.png", this.dt, '')}
                                            ${this.sensors.map((sensor) => this._renderParamRow(sensor.name, sensor.ico, sensor.val, sensor.st)).join('')}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    _renderParamRow(param, icon, value, tooltipValue) {

        var paramBlock = `
            <div title="${param}" class="x-grid-cell-inner" style="text-align: left;">
                ${param}
            </div>
        `;

        var valueBlock = `
            <div title="${value}" class="x-grid-cell-inner" style="text-align: left;">
                ${value}
            </div>
        `;

        return this._renderRow(paramBlock, icon, valueBlock, tooltipValue);
    }

    _renderMapLinksRow() {
        var paramBlock = `
            <a href="${this._getGoogleMapsLink()}" target="_blank" class="x-grid-cell-inner" style="text-align: left;">
                Google Maps
            </a>
        `;

        var valueBlock = `
            <a href="${this._getYandexMapsLink()}" target="_blank" class="x-grid-cell-inner" style="text-align: left;">
                Yandex Maps
            </a>
        `;

        return this._renderRow(paramBlock, '', valueBlock, '');
    }

    _renderRow(paramBlock, icon, valueBlock, tooltipValue) {
        return `
            <tr class="object-info-row x-grid-row">
                <td class="x-grid-cell x-grid-td x-grid-cell-gridcolumn-1052 popup-body-param">
                    ${paramBlock}
                </td>
                <td class="x-grid-cell x-grid-td x-grid-cell-actioncolumn-1053 x-action-col-cell popup-body-icon">
                    <div class="x-grid-cell-inner x-grid-cell-inner-action-col" style="text-align: center;">
                        ${fmtools.getIconSensor(icon)}
                    </div>
                </td>
                <td class="x-grid-cell x-grid-td x-grid-cell-gridcolumn-1054 popup-body-value">
                    ${valueBlock}
                </td>
                <td class="x-grid-cell x-grid-td x-grid-cell-actioncolumn-1055 x-action-col-cell x-grid-cell-last popup-body-status">
                    <div class="x-grid-cell-inner x-grid-cell-inner-action-col" style="text-align: center;">              
                        ${this._getCriticalityStatus(tooltipValue)}                 
                        <div class="x-action-col-icon x-action-col-0 ">
                        </div>
                    </div>
                </td>
            </tr>
        `;
    }

    _getCriticalityStatus(val) {
        return `<div style="margin-top: 3px;"> ${fmtools.getStatusEventIcon(val)}</div>`;
    }

    _getGoogleMapsLink() {
        var latLng = this.getLatLng();
        return `https://google.com/maps?q=loc:${latLng.lat},${latLng.lng}`;
    }

    _getYandexMapsLink() {
        var latLng = this.getLatLng();
        return `https://yandex.ru/maps/?pt=${latLng.lng},${latLng.lat}&z=${this.map.getZoom()}&l=map`;
    }
}
